import React, { useState } from "react";
import { withRouter } from "react-router";
import { Table, Modal, Button } from "antd";
import { showColumnAction } from "./AudienceColumn";
import "./AudienceTable.css";

function AudienceTable(props) {
  const { dataList, setVisible, setUserData, deleteData } = props;
  const [membersModalVisible, setMembersModalVisible] = useState(false);
  const [selectedAudience, setSelectedAudience] = useState(null);

  if (dataList === undefined) return <div />;

  const handleViewMembers = (record, e) => {
    e.stopPropagation();
    setSelectedAudience(record);
    setMembersModalVisible(true);
  };

  const memberLabel = selectedAudience?.channel === "sms" ? "Phone" : "Email";
  const memberList  = Array.isArray(selectedAudience?.emails) ? selectedAudience.emails : [];

  const memberColumns = [
    { title: "#", key: "index", width: 60, render: (_, __, idx) => idx + 1 },
    { title: memberLabel, dataIndex: "contact", key: "contact" },
  ];

  const columns = [
    {
      title: "Audience Name",
      dataIndex: "name",
      fixed: "left",
      width: 200,
      sorter: (a, b) => `${a.name}`.localeCompare(`${b.name}`),
    },
    {
      title: "# Members",
      dataIndex: "member_count",
      width: 120,
      align: "center",
      sorter: (a, b) => a.member_count - b.member_count,
      render: (count, record) => (
        <span
          style={{ color: "var(--mainColor)", cursor: "pointer", textDecoration: "underline" }}
          onClick={(e) => handleViewMembers(record, e)}
        >
          {count ?? 0}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "created_date",
      width: 150,
      render: (info) => {
        if (info !== undefined && info != null && info != "") {
          let year = info.split("-")[0];
          let month = info.split("-")[1];
          let day = info.split("-")[2];
          return month + "/" + day + "/" + year.substr(-2);
        }
        return info;
      },
      sorter: (a, b) => `${a.created_date}`.localeCompare(`${b.created_date}`),
    },
    {
      title: "Action",
      dataIndex: "operator",
      width: 155,
      fixed: "right",
      render: (op, info) => {
        return showColumnAction(info, setVisible, setUserData, deleteData);
      },
    },
  ];

  const dataSource =
    dataList.length == 0
      ? []
      : dataList.map((data, index) => {
          return { ...data, key: index };
        });

  return (
    <>
      <div className="info-list-widget">
        <Table
          columns={columns}
          dataSource={dataSource}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          scroll={{ x: 600 }}
          pagination={{ pageSize: 10 }}
        />
      </div>

      <Modal
        title={`Members: ${selectedAudience?.name || ""}`}
        open={membersModalVisible}
        onCancel={() => { setMembersModalVisible(false); setSelectedAudience(null); }}
        footer={[
          <Button key="close" onClick={() => { setMembersModalVisible(false); setSelectedAudience(null); }}>
            Close
          </Button>,
        ]}
        width={500}
      >
        {memberList.length === 0 ? (
          <p style={{ textAlign: "center", padding: "24px", color: "#999" }}>No members found.</p>
        ) : (
          <Table
            columns={memberColumns}
            dataSource={memberList.map((m, i) => ({ key: i, contact: m }))}
            pagination={{ pageSize: 20, showSizeChanger: true, pageSizeOptions: ["10", "20", "50", "100"] }}
            size="small"
          />
        )}
      </Modal>
    </>
  );
}

export default withRouter(AudienceTable);
